module.exports = __webpack_public_path__ + "static/img/卡萨帝艺术电视 壁画M70.4531a18a.png";